<template>
    <div>
        <div>
            <div class="header">
                <v-btn
                    v-if="!isEditing && permissionUpdate"
                    @click="toggleEdit()"
                    outlined
                    width="180"
                    color="primary">
                    <v-icon
                        class="pr-2">
                        edit
                    </v-icon>
                    {{ $vuetify.lang.t('$vuetify.companyProfile.edit') }}
                </v-btn>
                <div
                    v-if="isEditing">
                    <v-btn
                        @click="cancel()"
                        outlined
                        class="mr-2"
                        width="180"
                        color="primary">
                        {{ $vuetify.lang.t('$vuetify.companyProfile.cancel') }}
                    </v-btn>

                    <v-btn
                        @click="save()"
                        width="180"
                        color="primary">
                        {{ $vuetify.lang.t('$vuetify.companyProfile.save') }}
                    </v-btn>
                </div>
            </div>

            <v-form
                lazy-validation
                ref="form"
                v-model="valid">
                <v-container>
                    <v-row>
                        <v-col
                            cols="7"
                            class="pl-0">
                            <v-card class="content-container">
                                <v-container class="pa-10">
                                    <v-row>
                                        <v-col class="ml-2">
                                            <span class="profile-header locale-font">
                                                {{ $vuetify.lang.t('$vuetify.companyProfile.profile') }}
                                            </span>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col
                                            cols="3"
                                            offset="1"
                                            class="profile-company-image">
                                            <profile
                                                :isEditing="isEditing"
                                                @change-profile-img="changeProfileImg"
                                                :img="form.companyLogo"/>
                                        </v-col>
                                        <v-col
                                            cols="8">
                                            <v-container>
                                                <v-row>
                                                    <v-col
                                                        cols="6">
                                                        <v-text-field
                                                            :label="this.$vuetify.lang.t('$vuetify.companyProfile.companyName')"
                                                            v-model="form.companyName"
                                                            autocomplete="off"
                                                            placeholder=" "
                                                            :readonly="!isEditing"
                                                            :error-messages="errors.name">
                                                        </v-text-field>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col>
                                                        <v-textarea
                                                            :label="this.$vuetify.lang.t('$vuetify.companyProfile.hqAddress')"
                                                            v-model="form.hqAddress"
                                                            rows="2"
                                                            autocomplete="off"
                                                            placeholder=" "
                                                            no-resize
                                                            :readonly="!isEditing"
                                                            :error-messages="errors.address">
                                                        </v-textarea>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col>
                                                        <v-textarea
                                                            :label="this.$vuetify.lang.t('$vuetify.companyProfile.businessDescription')"
                                                            v-model="form.businessDescription"
                                                            rows="2"
                                                            autocomplete="off"
                                                            placeholder=" "
                                                            no-resize
                                                            :readonly="!isEditing"
                                                            :error-messages="errors.description">
                                                        </v-textarea>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card>
                        </v-col>
                        <v-col
                            cols="5"
                            class="pr-0">
                            <v-card class="contact-card content-container">
                                <v-container class="pa-10">
                                    <v-row>
                                        <v-col
                                            class="ml-2">
                                            <span class="profile-header locale-font">
                                                {{ $vuetify.lang.t('$vuetify.companyProfile.contact') }}
                                            </span>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <v-container>
                                                <v-row>
                                                    <v-col
                                                        cols="6">
                                                        <v-text-field
                                                            :label="this.$vuetify.lang.t('$vuetify.companyProfile.firstName')"
                                                            v-model="form.contact_firstname"
                                                            autocomplete="off"
                                                            placeholder=" "
                                                            :readonly="!isEditing"
                                                            :error-messages="errors.contact_firstname"
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col
                                                        cols="6">
                                                        <v-text-field
                                                            :label="this.$vuetify.lang.t('$vuetify.companyProfile.lastName')"
                                                            v-model="form.contact_lastname"
                                                            autocomplete="off"
                                                            placeholder=" "
                                                            :readonly="!isEditing"
                                                            :error-messages="errors.contact_lastname"
                                                        ></v-text-field>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col
                                                        cols="6">
                                                        <v-text-field
                                                            :label="this.$vuetify.lang.t('$vuetify.companyProfile.email')"
                                                            v-model="form.contact_email"
                                                            autocomplete="on"
                                                            placeholder=" "
                                                            :readonly="!isEditing"
                                                            :rules="emailRules"
                                                            :error-messages="errors.contact_email"
                                                        ></v-text-field>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col
                                                        cols="6">
                                                        <v-text-field
                                                            :label="this.$vuetify.lang.t('$vuetify.companyProfile.phoneNumber')"
                                                            v-model="form.contact_number"
                                                            autocomplete="off"
                                                            placeholder=" "
                                                            v-mask = "'## ### ####'"
                                                            :rules="phoneRules"
                                                            :error-messages="errors.contact_number"
                                                            :prefix="`(${nationalTelCode})`"
                                                            :readonly="!isEditing"
                                                        ></v-text-field>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-form>
        </div>
    </div>
</template>

<script>
import { mask } from 'vue-the-mask'
import Profile from '@/components/Profile'
import permissionConstant from '@/constants/permissions.js'

export default {
    name: 'CompanyProfile',
    components: {
        Profile
    },

    directives: {
        mask
    },

    data () {
        return {
            valid: true,
            isEditing: false,
            form: {
                companyName: '',
                hqAddress: '',
                businessDescription: '',
                companyLogo: '',
                contact_firstname: '',
                contact_lastname: '',
                contact_email: '',
                contact_number: ''
            },
            emailRules: [
                vmail => !!vmail || this.$vuetify.lang.t('$vuetify.companyProfile.emailIsRequired'),
                vmail => /.+@.+\..+/.test(vmail) || this.$vuetify.lang.t('$vuetify.companyProfile.emailMustBeValid')
            ],
            phoneRules: [
                v => v.length === 11 || this.$vuetify.lang.t('$vuetify.companyProfile.incorrectPhoneNubmer')
            ],
            nationalTelCode: '+66',
            tmpForm: {},
            permissionUpdate: true,
            errors: {}
        }
    },

    methods: {
        toggleEdit () {
            this.tmpForm = JSON.parse(JSON.stringify(this.form))
            this.isEditing = !this.isEditing
        },

        async getCompanyInfo () {
            const res = await this.axios.get('company/get')

            if (res && res.data && res.data.status === 'ok') {
                this.form.companyName = res.data.company.name
                this.form.hqAddress = res.data.company.address
                this.form.businessDescription = res.data.company.description
                this.form.companyLogo = res.data.company.f_path
                this.form.contact_firstname = res.data.company.contact_firstname
                this.form.contact_lastname = res.data.company.contact_lastname
                this.form.contact_email = res.data.company.contact_email
                this.form.contact_number = res.data.company.contact_number.slice(3)
            }
        },

        changeProfileImg (event) {
            const fileList = event.target.files

            const reader = new FileReader()
            let imgBase64 = null

            if (fileList[0]) {
                reader.onload = () => {
                    imgBase64 = reader.result
                    this.form.companyLogo = imgBase64
                }

                reader.readAsDataURL(fileList[0])
            }
        },

        cancel () {
            this.form = JSON.parse(JSON.stringify(this.tmpForm))
            this.isEditing = false
        },

        async save () {
            this.$store.dispatch('setLoading', true)

            const form = {
                name: this.form.companyName.trim(),
                address: this.form.hqAddress.trim(),
                description: this.form.businessDescription.trim(),
                contact_firstname: this.form.contact_firstname.trim(),
                contact_lastname: this.form.contact_lastname.trim(),
                contact_email: this.form.contact_email.trim(),
                contact_number: `${this.nationalTelCode} ${this.form.contact_number}`
            }

            if (this.form.companyLogo !== this.tmpForm.companyLogo) {
                form.image = this.form.companyLogo
            }

            const res = await this.axios.put('company/edit', form)

            if (res && res.data && res.data.status === 'ok') {
                this.checkForUpadatingCompanyProfileImg()
                this.toggleEdit()
                this.$store.dispatch('setLoading', false)

                this.$refs.form.resetValidation()
                this.errors = {}

                this.$notify({
                    title: this.$vuetify.lang.t('$vuetify.companyProfile.congratulation'),
                    text: this.$vuetify.lang.t('$vuetify.companyProfile.companyProfileIsUpdated'),
                    type: 'success'
                })
            } else if (res && res.data && res.data.status === 'error_inputs') {
                this.errors = res.data.errors
                this.$store.dispatch('setLoading', false)
                for (const property in this.errors) {
                    this.$notify({
                        title: this.$vuetify.lang.t('$vuetify.companyProfile.errorMessage'),
                        text: this.errors[property],
                        type: 'error'
                    })
                }
            }
        },

        checkForUpadatingCompanyProfileImg () {
            if (this.form.companyLogo !== this.tmpForm.companyLogo) {
                this.$store.dispatch('changeCompanyProfileImg', this.form.companyLogo)
            }
        },

        checkPermission () {
            this.permissionUpdate = this.$util.checkPermission(permissionConstant.company.update)
        }
    },

    async mounted () {
        await this.getCompanyInfo()
        this.$refs.form.resetValidation()
        this.checkPermission()
    },

    watch: {
        '$vuetify.lang.current': {
            handler: function (after, before) {
                this.$util.recheckValidate(this.$refs.form.inputs)
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.header {
    display: flex;
    justify-content: flex-end;
}
.profile-header {
    font-size: 24px;
}
.profile-company-image {
    display: flex;
    justify-content: center;
    margin-top: 2rem;
}
.contact-card {
    height: 516px;
}
</style>
